import React from 'react';
import Reveal from './Reveal';
import { PROCESS } from '../mock';
import PatternBg from './PatternBg';

export default function Methodology() {
  return (
    <section className="relative overflow-hidden bg-[var(--ob-bg)] py-24 md:py-32">
      <PatternBg
        size={150}
        opacity={0.07}
        mask="radial-gradient(120% 120% at 85% 100%, #000 8%, transparent 68%)"
      />
      <div className="relative mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            The OnBrand Process
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-6xl">
            Let’s chat this week. Worst case, a free audit.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PROCESS.map((p, i) => (
            <Reveal key={p.step} delay={i * 100}>
              <div className="group relative h-full overflow-hidden rounded-3xl border border-[var(--ob-line)] bg-white p-7">
                <span className="font-display text-5xl font-extrabold text-[var(--ob-line)] transition-colors group-hover:text-[var(--ob-accent)]">
                  {p.step}
                </span>
                <h3 className="mt-5 font-display text-xl font-bold text-[var(--ob-ink)]">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--ob-ink-soft)]">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
